import {
  DocumentReferenceMetadata,
  IReferenceGenerator,
  MappingReferenceData,
} from './types';

abstract class BaseReferenceGenerator<TGeneratedReferences = any> 
implements IReferenceGenerator<TGeneratedReferences> {

  getDocumentReferences(referenceList: MappingReferenceData[] = []): DocumentReferenceMetadata {
    if (!referenceList || referenceList.length === 0) {
      return { documentIds: [], metadata: [] };
    }

    // Group references by document ID
    const docMap = new Map<number, MappingReferenceData[]>();
    referenceList.forEach(item => {
      const existing = docMap.get(item.document_reference) || [];
      docMap.set(item.document_reference, [...existing, item]);
    });

    // Build metadata for each document
    const metadata = Array.from(docMap.entries()).map(([documentId, refs]) => ({
      documentId,
      fields: refs.map(ref => ({
        fieldName: ref.field_name,
        sheetName: ref.sheet_name,
        cellReferences: ref.cell_references,
      })),
    }));

    return {
      documentIds: Array.from(docMap.keys()),
      metadata,
    };
  }

  abstract generateMappingReferences(sheetAttributeData: any): TGeneratedReferences;
  
  abstract getReferenceMetadataForCell(
    period: string,
    fieldName: string,
    references: TGeneratedReferences
  ): MappingReferenceData[] | null;
  
  abstract getFieldModelType(fieldName: string): string | null;
}

export default BaseReferenceGenerator;

